
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.067 4.863l-6.804 6.804 6.804 6.804v-3.96h10.666V8.822H10.067v-3.96zM1 11.667L11.667 1v6.222h10.666v8.89H11.667v6.221L1 11.667z"}})])
          )
        }
      }
    